export default "__VITE_ASSET__d47220c8__"